"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceEnum = void 0;
var DeviceEnum;
(function (DeviceEnum) {
    DeviceEnum["WEB"] = "WEB";
    DeviceEnum["MOBILE"] = "MOBILE";
    DeviceEnum["API"] = "API";
})(DeviceEnum = exports.DeviceEnum || (exports.DeviceEnum = {}));
//# sourceMappingURL=deviceEnum.js.map